import { HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useActionPreviewStyles } from '../useActionPreviewStyles';

export type ActionPreviewContentProps = HTMLChakraProps<'div'>;

export const ActionPreviewContent: React.FC<ActionPreviewContentProps> =
  forwardRef<ActionPreviewContentProps, 'div'>(
    ({ children, ...props }, ref) => {
      const { content } = useActionPreviewStyles();

      return (
        <chakra.div
          sx={content}
          className="action-preview-content"
          {...props}
          ref={ref}
        >
          {children}
        </chakra.div>
      );
    },
  );
ActionPreviewContent.displayName = 'ActionPreviewContent';
